/**
 * Requests content access from the server.
 * Returns a promise that resolves with the response JSON.
 *
 * @param {string} contentToken The content token to request access for.
 * @return {Promise} Resolves with the parsed JSON response.
 */
function requestContentAccess(contentToken) {
	var language = document.documentElement.lang;
	var url = '/include/ajax/knowledge.php?action=play_content&content_token=' + encodeURIComponent(contentToken) + '&language=' + encodeURIComponent(language);

	return fetch(url)
		.then(function(response) {
			if (!response.ok) {
				console.error('Content access request failed:', response.status, response.statusText);
				return { success: false, error: 'Request failed with status ' + response.status };
			}
			return response.text().then(function(text) {
				try {
					return JSON.parse(text);
				} catch (e) {
					console.error('Content access response (not JSON):', text);
					return { success: false, error: 'Invalid JSON response.' };
				}
			});
		})
		.catch(function(error) {
			console.error('Content access request error:', error);
			return { success: false, error: error.message };
		});
}

/**
 * Handles an access-denied response by redirecting to the access page.
 */
function handleAccessDenied() {
	if (typeof window.contentAccessUrl === 'string' && window.contentAccessUrl.length > 0) {
		window.location.href = window.contentAccessUrl;
	} else {
		window.location.href = '/' + document.documentElement.lang + '/access';
	}
}

/**
 * Loads content via the access endpoint and plays video inline.
 * Replaces the thumbnail with a video player on success.
 * Redirects to the access page if access is denied.
 *
 * @param {Event}       event            The click event.
 * @param {HTMLElement} thumbnailElement The thumbnail container element.
 * @param {string}      contentToken     The content token to request.
 */
function playVideo(event, thumbnailElement, contentToken) {
	event.preventDefault();
	event.stopPropagation();

	requestContentAccess(contentToken).then(function(data) {
		if (data.success) {
			// Create video element.
			var video = document.createElement('video');
			video.controls = true;
			video.autoplay = true;
			video.style.position = 'absolute';
			video.style.top = '0';
			video.style.left = '0';
			video.style.width = '100%';
			video.style.height = '100%';
			video.style.objectFit = 'cover';
			video.src = data.url;

			// Clear thumbnail and insert video.
			thumbnailElement.innerHTML = '';
			thumbnailElement.appendChild(video);
			thumbnailElement.style.cursor = 'default';
			thumbnailElement.onclick = null;
		} else if (data.access_denied) {
			handleAccessDenied();
		}
	});
}

/**
 * Loads content via the access endpoint and starts playback on a page video player.
 * Sets the video source and plays on success.
 * Redirects to the access page if access is denied.
 *
 * @param {HTMLElement} playerElement The video element to play.
 * @param {string}      contentToken  The content token to request.
 */
function playContentVideo(playerElement, contentToken) {
	requestContentAccess(contentToken).then(function(data) {
		if (data.success) {
			playerElement.src = data.url;
			playerElement.play();

			// Hide play overlay if present.
			var overlay = playerElement.parentElement.querySelector('.content-play-overlay');
			if (overlay) {
				overlay.style.display = 'none';
			}
		} else if (data.access_denied) {
			handleAccessDenied();
		}
	});
}

/**
 * Loads content via the access endpoint and opens the download URL.
 * Redirects to the access page if access is denied.
 *
 * @param {Event}  event        The click event.
 * @param {string} contentToken The content token to request.
 */
function downloadContent(event, contentToken) {
	event.preventDefault();
	event.stopPropagation();

	requestContentAccess(contentToken).then(function(data) {
		if (data.success) {
			window.open(data.url, '_blank');
		} else if (data.access_denied) {
			handleAccessDenied();
		}
	});
}

/**
 * Navigates to a content viewing page.
 *
 * @param {string} contentUrl The URL of the content to view.
 */
function viewContent(contentUrl) {
	window.location.href = contentUrl;
}

// Attach to window so they are accessible from inline onclick handlers.
window.downloadContent = downloadContent;
window.playContentVideo = playContentVideo;
window.playVideo = playVideo;
window.viewContent = viewContent;
